import {
  object as YupObject,
  string as YupString,
  number as YupNumber,
} from 'yup'

export const validationSchema = YupObject().shape(
  {
    verticalId: YupNumber().typeError('Please select content type.'),
    projectId: YupString()
      .trim()
      .when('projectName', {
        is: val => val && val.length > 0,
        then: YupString().notRequired().nullable(),
        otherwise: YupString().required('Please select a project.'),
      }),
    projectName: YupString()
      .trim()
      .when('projectId', {
        is: val => val && val === 'new',
        then: YupString().required('Please enter project name.'),
      }),
  },
  [['projectId', 'projectName']]
)
